enum JobStatus {
    Pending,
    Processing,
    Success,
    Error
}

export default JobStatus;